import { Injectable } from '@angular/core';
import { DownloadService } from '../core-services/Download.service';

@Injectable({ providedIn: 'root' })
export class CsvService {
    constructor(private downloadService: DownloadService) {}

    // takes in a filename and the source data as an array of json
    exportToCsv(filename: string, dataRows: object[]): void {
        if (!dataRows || !dataRows.length) {
            return;
        }

        const separator = ',';
        const csvKeys = Object.keys(dataRows[0]);
        const csvContent =
            csvKeys.join(separator) +
            '\n' +
            dataRows
                .map((row: any) =>
                    csvKeys
                        .map((k) => {
                            const cell =
                                row[k] === null || row[k] === undefined
                                    ? ''
                                    : row[k];
                            return `"${cell}"`;
                        })
                        .join(separator)
                )
                .join('\n');

        // convert to CSV file and download
        this.downloadService.downloadCSV(filename, csvContent);
    }
}
